import {
    AuthorizationStatus,
    getMessaging, getToken,
    isDeviceRegisteredForRemoteMessages, onMessage, onTokenRefresh, registerDeviceForRemoteMessages,
    requestPermission
} from "@react-native-firebase/messaging";
import { useEffect, useRef } from "react";
import { PermissionsAndroid, Platform } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { cloudToken } from "@/stores/mainSlice";
import { backendRequest } from "@/stores/thunks";
import { getApp } from "@react-native-firebase/app";
import { handleNotificationData } from "@/containers/navigation";


export const FcmNotifications = (props) => {

    const dispatch = useDispatch()
    const online = useSelector(state => state.server.online)
    const isNative = Platform.OS !== "web";
    const onlineRef = useRef(online);

    let app;
    let messaging;
    if(isNative){
        app = getApp();
        messaging = getMessaging(app)
    }

    async function requestUserPermission() {
        if (!isNative) return;
        if (Platform.OS === 'ios') {
            // iOS: The requestPermission() method handles everything for you.
            const authStatus = await requestPermission(messaging);
            const enabled =
                authStatus === AuthorizationStatus.AUTHORIZED ||
                authStatus === AuthorizationStatus.PROVISIONAL;

            if (enabled) {
                console.log('iOS: Authorization status:', authStatus);
            }
        } else if (Platform.OS === 'android') {
            // Android: API 33+ requires explicit permission request
            if (Platform.Version >= 33) {
                try {
                    const granted = await PermissionsAndroid.request(
                        PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
                    );
                    if (granted === PermissionsAndroid.RESULTS.GRANTED) {
                        console.log('Android API 33+: Notification permission granted.');
                    } else {
                        console.log('Android API 33+: Notification permission denied.');
                    }
                } catch (error) {
                    console.error('Android permission request error:', error);
                }
            } else {
                // Android: API 32 and below, permission is granted by default
                // This call will always resolve to 'authorized' on these versions.
                const authStatus = await requestPermission(messaging);
                if (authStatus === AuthorizationStatus.AUTHORIZED) {
                    console.log('Android API < 33: Notification permission is authorized by default.');
                }
            }
        }
    }

    async function ensureToken() {
        const registered = isDeviceRegisteredForRemoteMessages(messaging)
        if (!registered) {
            await registerDeviceForRemoteMessages(messaging);
        }
        const token = await getToken(messaging);
        console.log("Cloud Token: " + token)
        dispatch(cloudToken({token: token}))
    }

    function handleMessage() {
        return onMessage(messaging, async (remoteMessage) => {
            console.log('A new FCM message arrived!', JSON.stringify(remoteMessage));
            const data = remoteMessage.data?.nav;
            if (onlineRef.current){
                dispatch(backendRequest('GET_WORKFLOWS_INLINE', '/contact/user', null, 'GET', false)).then(() => {
                    // I know that the workflow is loaded
                   if (data) {
                       handleNotificationData(data, 'foreground')
                   }
                })
            } else {
                // TODO sollte eig nicht anzeigen wenn offline, vllt notification queue?
                // handleNotificationData(data, 'foreground')
            }
        });
    }

    function handleTokenRefresh(){
        return onTokenRefresh(messaging,token => {
            console.log("FCM Token refreshed:", token);
            dispatch(cloudToken({token: token}))
        });
    }

    useEffect(() => {
        if(!isNative) return
        let unsubscribeMessage;
        let unsubscribeToken;

        (async () => {
            await requestUserPermission()
            await ensureToken()
            unsubscribeMessage = handleMessage()
            unsubscribeToken = handleTokenRefresh()
        })();

        return () => {
            unsubscribeMessage?.()
            unsubscribeToken?.()
        }
    }, [])

    useEffect(() => {
        if (!isNative) return;
        if (online) {
            (async () => {
                await ensureToken();
            })();
        }
    }, [isNative, online]);

    useEffect(() => {
        onlineRef.current = online;
    }, [online]);

    return (
        props.children
    )
}
